<template>
    <div >
        <el-row  :gutter="20">
            <el-col :span="8">
                <el-card class="box-card" >
                    <div slot="header" class="clearfix">
                        <span>收款银行卡配置</span>
                        <el-button type="success" size="small" @click="addCard" style="float:right"  icon="el-icon-plus" plain>添加</el-button>
                    </div>
                    <el-table
                    :data="cardList"
                    style="width: 100%">
                    <el-table-column
                    width="90"
                        prop="Name"
                        label="名称">
                    </el-table-column>
                    <el-table-column
                    width="70"
                        prop="AccountName"
                        label="开户名">
                    </el-table-column>
                    <el-table-column
                    width="120"
                        prop="AccountBankName"
                        label="开户行名称">
                    </el-table-column>
                    <el-table-column
                        prop="CardNo"
                        label="卡号">
                    </el-table-column>
                     <!-- <el-table-column
                        label="收款码">
                            <template slot-scope="scope">
                                <el-link @click="showImg(scope.row.CollectionCode)" icon="el-icon-picture" type="primary">点击查看</el-link>
                            </template>
                    </el-table-column> -->
                    <el-table-column
                    width="60"
                        label="操作">
                            <template slot-scope="scope">
                                  <el-button size="mini" @click="editCard(scope.row)" type="primary" icon="el-icon-edit" circle></el-button>
                            </template>
                    </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
             <el-col :span="8">
                <el-card class="box-card" >
                    <div slot="header" class="clearfix">
                        <span>收款支付宝配置</span>
                        <el-button type="success" size="small" @click="addAlipay" style="float:right"  icon="el-icon-plus" plain>添加</el-button>
                    </div>
                    <el-table
                    :data="alipayList"
                    style="width: 100%">
                    <el-table-column
                    width="120"
                        prop="AccountName"
                        label="名称">
                    </el-table-column>
                    <el-table-column
                    width="150"
                        prop="Account"
                        label="支付宝账号">
                    </el-table-column>
                     <el-table-column
                        label="收款码">
                            <template slot-scope="scope">
                                <el-link @click="showImg(scope.row.CollectionCode)" icon="el-icon-picture" type="primary">点击查看</el-link>
                            </template>
                    </el-table-column>
                    <el-table-column
                        label="操作">
                            <template slot-scope="scope">
                                  <el-button size="mini" @click="editAlipay(scope.row)" type="primary" icon="el-icon-edit" circle></el-button>
                            </template>
                    </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
            <el-col :span="8">
                <el-card class="box-card" >
                    <div slot="header" class="clearfix">
                        <span>客服信息配置</span>
                    </div>
                    <el-form :model="config" :rules="rules2" ref="configForm" label-width="200px" >
                        <el-form-item label="客服联系电话：" prop="Phone">
                            <el-input v-model="config.Phone"></el-input>
                        </el-form-item>
                        <el-form-item label="新手常见问题QQ：" prop="QQOne">
                            <el-input v-model="config.QQOne"></el-input>
                        </el-form-item>
                        <el-form-item label="请输入发布任务问题QQ：" prop="QQTwo">
                            <el-input v-model="config.QQTwo"></el-input>
                        </el-form-item>
                        <el-form-item label="请输入充值提现问题QQ：" prop="QQThree">
                            <el-input v-model="config.QQThree"></el-input>
                        </el-form-item>
                        <el-form-item label="微信客服二维码地址：">
                            <el-input v-model="config.WeiXinUrl"></el-input>
                        </el-form-item>
                        <el-form-item label="微信公众号二维码地址：">
                            <el-input v-model="config.GongZhongHaoUrl"></el-input>
                        </el-form-item>
                        <el-form-item label="注册码" prop="InvitationCode">
                            <el-input v-model="config.InvitationCode"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="saveConfig">保存</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>
                <el-image-viewer 
                v-show="showViewer" 
                :on-close="closeImg" 
                :url-list="[imgUrl]" />
                <el-dialog title="编辑收款卡"   width="500px" :visible.sync="editCardVisible">
                    <el-form :model="card" label-width="120px" :rules="rules" ref="cardForm" >
                        <el-form-item label="名称" prop="Name">
                            <el-input v-model="card.Name"></el-input>
                        </el-form-item>
                        <el-form-item label="收款卡开户名" prop="AccountName">
                            <el-input v-model="card.AccountName"></el-input>
                        </el-form-item>
                        <el-form-item label="收款卡开户行" prop="AccountBankName">
                            <el-input v-model="card.AccountBankName"></el-input>
                        </el-form-item>
                        <el-form-item label="收款卡号" prop="CardNo">
                            <el-input v-model="card.CardNo"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="editCardVisible = false">取 消</el-button>
                        <el-button type="primary" @click="saveCard">确 定</el-button>
                    </div>
                </el-dialog>
                <el-dialog title="编辑支付宝"   width="500px" :visible.sync="editAlipayVisible">
                    <el-form :model="alipay" label-width="120px" :rules="alipayRules" ref="alipayForm" >
                        <el-form-item label="姓名" prop="AccountName">
                            <el-input v-model="alipay.AccountName"></el-input>
                        </el-form-item>
                        <el-form-item label="账号" prop="Account">
                            <el-input v-model="alipay.Account"></el-input>
                        </el-form-item>
                        <el-form-item label="收款码" prop="CollectionCode">
                            <el-upload 
                            :file-list="fileList"
                            :action="baseUrl+'/ReceivePayment/PushCollectionCode'"
                            list-type="picture-card"
                            :limit="1"
                            :on-preview="handlePictureCardPreview"
                            :on-success="pushImg"
                            accept="image/jpeg,image/jpg,image/png"
                            :multiple="false"
                            :on-exceed="exceed"
                            :on-remove="handleRemove">
                            <i class="el-icon-plus" ></i>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="editAlipayVisible = false">取 消</el-button>
                        <el-button type="primary" @click="saveAlipay">确 定</el-button>
                    </div>
                </el-dialog>
    </div>
</template>
<script>
import {receivePaymentGetAlipay,receivePaymentSaveAlipay , receivePaymentGet,manageGetConfig,receivePaymentSave,manageSaveConfig,uri} from '@/request.js'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
        components: {
        ElImageViewer
    },
    data(){
        return {
            fileList:[],
            baseUrl:uri,
            editCardVisible:false,
            editAlipayVisible:false,
            showViewer:false,
            imgUrl:"",
            cardList:[],
            alipayList:[],
            alipay:{AccountName:"",Account:"",CollectionCode:"",Id:0},
            card:{ CardNo:"",AccountName:"",AccountBankName:"" ,Name:"",Id:0},
            config:{
                GongZhongHaoUrl:"",
                Phone:"",
                QQOne:"",
                QQThree:"",
                QQTwo:"",
                WeiXinUrl:"",
                InvitationCode:"",
            },
            rules: {
                Name: [
                    { required: true, message: '请输入模板名称', trigger: 'blur' },
                    { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
                ],
                CardNo: [
                    { required: true, message: '请输入银行卡号', trigger: 'blur' },
                    { min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur' }
                ],
                AccountName: [
                    { required: true, message: '请填写银行卡开户名', trigger: 'blur' },
                    { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' }
                ],
                AccountBankName: [
                    { required: true, message: '请填写银行卡开户行名称', trigger: 'blur' },
                    { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
                ],
            },
            alipayRules: {
                AccountName: [
                    { required: true, message: '请输入支付宝账号姓名', trigger: 'blur' },
                    { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
                ],
                Account: [
                    { required: true, message: '请输入支付宝账号', trigger: 'blur' },
                    { min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur' }
                ],
                CollectionCode: [
                    { required: true, message: '请上传支付宝收款码', trigger: 'blur' },
                ],
            },

            rules2: {
                Phone: [
                    { required: true, message: '请输入客服联系电话', trigger: 'blur' },
                    { min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur' }
                ],
                QQOne: [
                    { required: true, message: '请输入新手常见问题QQ', trigger: 'blur' },
                    { min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur' }
                ],
                QQThree: [
                    { required: true, message: '请输入发布任务问题QQ', trigger: 'blur' },
                    { min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur' }
                ],
                QQTwo: [
                    { required: true, message: '请输入充值提现问题QQ', trigger: 'blur' },
                    { min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur' }
                ],
                InvitationCode: [
                    { required: true, message: '请输入通用注册码', trigger: 'blur' },
                    { min: 6, max: 6, message: '长度为 6 个字符', trigger: 'blur' }
                ],
            }
        };
    },
    mounted(){
        receivePaymentGet({},(res)=>{
            this.cardList=res.Result;
        })
        receivePaymentGetAlipay({},(res)=>{
            this.alipayList=res.Result;
        })
        manageGetConfig({},(res)=>{
            this.config=res.Result;
        });
    },
    methods:{

        exceed(){
            this.$message({
                message: '只可以上传一张图片哦',
                type: 'warning'
            });
        },
        handlePictureCardPreview(file){
            this.imgUrl=file.url;
            this.showViewer=true;
        },
        pushImg(response){
            if(response.IsSuccess){
                this.alipay.CollectionCode=response.Message;
            }else{
                this.$message.error('图片上传失败，请稍后重试');
            }
        },

        addCard(){
            this.card={ CardNo:"",AccountName:"",AccountBankName:"" ,Name:"",Type:1,Id:0};
            this.editCardVisible=true;
        },
        addAlipay(){
            this.alipay={AccountName:"",Account:"",CollectionCode:"",Id:0},
            this.fileList=[];
            this.editAlipayVisible=true;
        },
        editAlipay(scope){
            this.alipay={ 
                AccountName:scope.AccountName,
                Account:scope.Account,
                CollectionCode:scope.CollectionCode ,
                Id:scope.Id,
            };
            this.fileList=[{name:"img",url:scope.CollectionCode}];
            this.editAlipayVisible=true;
        },
        editCard(scope){
            this.card={ 
                CardNo:scope.CardNo,
                AccountName:scope.AccountName,
                AccountBankName:scope.AccountBankName ,
                Name:scope.Name,
                Type:scope.Type,
                Id:scope.Id
            };
            this.fileList=[{name:"img",url:scope.CollectionCode}];
            this.editCardVisible=true;
        },
        handleRemove(){
            this.alipay.CollectionCode="";
        },
        closeImg(){
            this.showViewer=false;
        },
        showImg(url){
            this.imgUrl=url
            this.showViewer=true;
        },
        saveCard(){
            this.$refs["cardForm"].validate((valid) => {
                if (valid) {
                    receivePaymentSave(this.card,(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.editCardVisible=false;
                            receivePaymentGet({},(res)=>{
                                this.cardList=res.Result;
                            })
                        }else{
                            this.$message.error(res.Message);
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        saveAlipay(){
            this.$refs["alipayForm"].validate((valid) => {
                if (valid) {
                    receivePaymentSaveAlipay(this.alipay,(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.editAlipayVisible=false;
                            receivePaymentGetAlipay({},(res)=>{
                                this.alipayList=res.Result;
                            })
                        }else{
                            this.$message.error(res.Message);
                        }
                    })
                } else {
                    return false;
                }
            });
        },

        saveConfig(){
            this.$refs["configForm"].validate((valid) => {
                if (valid) {
                    manageSaveConfig(this.config,()=>{
                       this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    })
                } else {
                    return false;
                }
            });
        },
    },
}
</script>